import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import Q1 from "../assets/Quote.svg";

const TestimonialCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(1); // Track active slide index

  return (
    <div className="mt-14 flex justify-center w-[100%] md:hidden">
      {/* Constrain Swiper container width */}
      <div className="w-full lg:w-[800px] mx-0">
        <Swiper
          modules={[EffectCoverflow, Autoplay]}
          effect="coverflow"
          centeredSlides={true}
          initialSlide={1} // Start with the second slide in the middle
          slidesPerView="auto"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          loopAdditionalSlides={2} // Add extra slides for smoother looping
          allowTouchMove={false} // Disable user dragging
          speed={500}
          breakpoints={{
            320: {
              slidesPerView: 1.5, // Small screen: Show 1.5 slides (middle card + partial others)
              spaceBetween: 60,
            },
            425: {
                slidesPerView: 1.6, // Small screen: Show 1.5 slides (middle card + partial others)
                spaceBetween: 30,
            },
            768: {
              slidesPerView: 2.5, // Medium screen: Show 2.5 slides
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: 3, // Large screen: Show 3 slides
              spaceBetween: 30,
            },
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)} // Track active slide index
          className="swiper-container"
          style={{ overflow: 'visible' }}
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <div
              className={`w-[220px] h-[140px] md:w-[250px] md:h-[160px] bg-whiteExtra rounded-xl flex flex-col p-4 transition-opacity duration-500 ${
                activeIndex === 0 ? 'opacity-100' : 'opacity-50'
              }`}
            >
              <img className="w-4 h-4 md:w-6 md:h-6 xl:w-10 xl:h-10" src={Q1} alt="" />
              <p className="my-2 leading-12 md:text-14 text:11 md:leading-14 xl:leading-20 xl:text-22">Estudy made my Poland study abroad experience stress-free and unforgettable.</p>
              <div className="flex mt-auto">
                <div className="w-7 h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                  {/* <img src="" alt="" /> */}
                </div>
                <div className="flex-col ml-2 md:ml-2 xl:ml-4">
                  <p className="font-medium text-14 leading-14 md:text-14 md:leading-14 xl:text-22 xl:leading-21">Salma Khaled</p>
                  <p className="text-12 leading-12 md:text-12 md:leading-14 xl:text-16 xl:leading-14">SAT Student</p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div
              className={`w-[220px] h-[140px] md:w-[250px] md:h-[160px] bg-whiteExtra rounded-xl flex flex-col p-4 transition-opacity duration-500 ${
                activeIndex === 1 ? 'opacity-100' : 'opacity-50'
              }`}
            >
              <img className="w-4 h-4 md:w-6 md:h-6 xl:w-10 xl:h-10" src={Q1} alt="" />
              <p className="my-2 leading-12 md:text-14 text:11 md:leading-14 xl:leading-20 xl:text-22">Estudy provided me with a reliable and affordable solution for studying abroad in Poland.</p>
              <div className="flex mt-auto">
                <div className="w-7 h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                  {/* <img src="" alt="" /> */}
                </div>
                <div className="flex-col ml-2 md:ml-2 xl:ml-4">
                  <p className="font-medium text-14 leading-14 md:text-14 md:leading-14 xl:text-22 xl:leading-21">Essam Ahmad</p>
                  <p className="text-12 leading-12 md:text-12 md:leading-14 xl:text-16 xl:leading-14">Thanawya Amma</p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <div
              className={`w-[220px] h-[140px] md:w-[250px] md:h-[160px] bg-whiteExtra rounded-xl flex flex-col p-4 transition-opacity duration-500 ${
                activeIndex === 2 ? 'opacity-100' : 'opacity-50'
              }`}
            >
              <img className="w-4 h-4 md:w-6 md:h-6 xl:w-10 xl:h-10" src={Q1} alt="" />
              <p className="my-2 leading-14 md:text-14 md:leading-14 xl:leading-20 xl:text-22">I am thrilled with the exceptional service provided by Estudy.</p>
              <div className="flex mt-auto">
                <div className="w-7 h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                  {/* <img src="" alt="" /> */}
                </div>
                <div className="flex-col ml-2 md:ml-2 xl:ml-4">
                  <p className="font-medium text-14 leading-14 md:text-14 md:leading-14 xl:text-22 xl:leading-21">Omar Gamal</p>
                  <p className="text-12 leading-12 md:text-12 md:leading-14 xl:text-16 xl:leading-14">IGCSE Student</p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 4 */}
          <SwiperSlide>
            <div
              className={`w-[220px] h-[140px] md:w-[250px] md:h-[160px] bg-whiteExtra rounded-xl flex flex-col p-4 transition-opacity duration-500 ${
                activeIndex === 3 ? 'opacity-100' : 'opacity-50'
              }`}
            >
              <img className="w-4 h-4 md:w-6 md:h-6 xl:w-10 xl:h-10" src={Q1} alt="" />
              <p className="my-2 leading-12 md:text-14 text:11 md:leading-14 xl:leading-20 xl:text-22">Estudy made my Poland study abroad experience stress-free and unforgettable.</p>
              <div className="flex mt-auto">
                <div className="w-7 h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                  {/* <img src="" alt="" /> */}
                </div>
                <div className="flex-col ml-2 md:ml-2 xl:ml-4">
                  <p className="font-medium text-14 leading-14 md:text-14 md:leading-14 xl:text-22 xl:leading-21">Salma Khaled</p>
                  <p className="text-12 leading-12 md:text-12 md:leading-14 xl:text-16 xl:leading-14">SAT Student</p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 5 */}
          <SwiperSlide>
            <div
              className={`w-[220px] h-[140px] md:w-[250px] md:h-[160px] bg-whiteExtra rounded-xl flex flex-col p-4 transition-opacity duration-500 ${
                activeIndex === 4 ? 'opacity-100' : 'opacity-50'
              }`}
            >
             <img className="w-4 h-4 md:w-6 md:h-6 xl:w-10 xl:h-10" src={Q1} alt="" />
             <p className="my-2 leading-12 md:text-14 text:11 md:leading-14 xl:leading-20 xl:text-22">Estudy provided me with a reliable and affordable solution for studying abroad in Poland.</p>
              <div className="flex mt-auto">
                <div className="w-7 h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                  {/* <img src="" alt="" /> */}
                </div>
                <div className="flex-col ml-2 md:ml-2 xl:ml-4">
                  <p className="font-medium text-14 leading-14 md:text-14 md:leading-14 xl:text-22 xl:leading-21">Essam Ahmed</p>
                  <p className="text-12 leading-12 md:text-12 md:leading-14 xl:text-16 xl:leading-14">Thanawya Amma</p>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 6 */}
          <SwiperSlide>
            <div
              className={`w-[220px] h-[140px] md:w-[250px] md:h-[160px] bg-whiteExtra rounded-xl flex flex-col p-4 transition-opacity duration-500 ${
                activeIndex === 5 ? 'opacity-100' : 'opacity-50'
              }`}
            >
              <img className="w-4 h-4 md:w-6 md:h-6 xl:w-10 xl:h-10" src={Q1} alt="" />
              <p className="my-2 leading-14 md:text-14 md:leading-14 xl:leading-20 xl:text-22">I am thrilled with the exceptional service provided by Estudy.</p>
              <div className="flex mt-auto">
                <div className="w-7 h-7 xl:w-10 xl:h-10 rounded-full bg-black">
                  {/* <img src="" alt="" /> */}
                </div>
                <div className="flex-col ml-2 md:ml-2 xl:ml-4">
                  <p className="font-medium text-14 leading-14 md:text-14 md:leading-14 xl:text-22 xl:leading-21">Omar Gamal</p>
                  <p className="text-12 leading-12 md:text-12 md:leading-14 xl:text-16 xl:leading-14">IGCSE Student</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default TestimonialCarousel;